import type { BonusType, KycPolicy, ScreenshotCategory } from '@/api/funnel-audits';

export const REGISTRATION_FIELD_LABELS: Record<string, string> = {
  phone: 'Phone', email: 'Email', password: 'Password', full_name: 'Full name',
  birth_date: 'Date of birth', currency: 'Account currency', promo_code: 'Promo code',
  gender: 'Gender', address: 'Address / country / city', terms_18plus: '18+ terms consent',
};

export const PAYMENT_METHOD_LABELS: Record<string, string> = {
  pix: 'Pix', upi: 'UPI', crypto: 'Crypto', bank_transfer: 'Bank transfer',
  skrill: 'Skrill', neteller: 'Neteller', cards: 'Cards',
};

export const BONUS_LABELS: Record<BonusType, string> = {
  non_sticky: 'Non-sticky', sticky: 'Sticky', no_deposit: 'No deposit', none: 'No bonus',
};

export const KYC_LABELS: Record<KycPolicy, string> = {
  on_deposit: 'On deposit', on_withdrawal: 'On withdrawal', not_required: 'Not required upfront',
};

export const SCREENSHOT_LABELS: Record<ScreenshotCategory, string> = {
  landing: 'Landing', registration: 'Registration', cashier: 'Cashier / deposit',
  lobby: 'Game lobby', other: 'Other',
};

export function offerLabel(offer: { brand: string | null; partner: string; geo: string }): string {
  const name = offer.brand?.trim() || offer.partner;
  return `${name} — ${offer.partner} — ${offer.geo}`;
}

export function auditOfferLabel(audit: { offer_brand: string | null; offer_partner: string }): string {
  return audit.offer_brand?.trim() || audit.offer_partner;
}

export function formatMinor(value: number): string {
  return (value / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export function parseMinor(value: string): number | null {
  const normalized = value.trim().replace(',', '.');
  if (!/^\d+(?:\.\d{1,2})?$/.test(normalized)) return null;
  const [whole, fraction = ''] = normalized.split('.');
  const amount = Number(whole) * 100 + Number(fraction.padEnd(2, '0'));
  return Number.isSafeInteger(amount) ? amount : null;
}

export function formatFlag(value: number | null): string {
  return value == null ? '—' : value ? 'Yes' : 'No';
}

export function formatDate(value: string): string {
  return new Intl.DateTimeFormat(undefined, { dateStyle: 'medium', timeStyle: 'short' }).format(new Date(value));
}
